// Set global screen breakpoints
export const screen_xs = (window.screen_xs = 480);
export const screen_sm = (window.screen_sm = 768);
export const screen_md = (window.screen_md = 992);

// Re-export commonly used utility functions from global.js
export { getCookie, setCookie, showLoadingBar, removeLoadingBar, isEmail, isValidPostcode, getUrlParameter } from "./global.js";
